<template>
  <div class="container-fluid py-2">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0">
            <div class="d-flex justify-content-between">
              <h5 class="">
                Informações da Carteira
              </h5>
              <div class="d-flex justify-content-end">
                <argon-button size="sm" color="danger" variant="outline" data-bs-toggle="modal"
                  data-bs-target="#modal-clientes-bloqueados-painel" :pulse="true"
                  v-if="clientesBloqueadosPainel != null && clientesBloqueadosPainel.length > 0">
                  ({{ clientesBloqueadosPainel.length }}) Clientes Bloqueados Painel e ativos no PMS
                </argon-button>
              </div>
            </div>
          </div>
          <div class="card-body p-3">
            <div class="row">
              <clientes-counter-card :count="statusClientes.ativos" title="Ativos" :selected="isAtivosSelected"
                @click="setAtivoSelected(true)" />
              <clientes-counter-card :count="statusClientes.inativos" title="Inativos"
                :selected="isAtivosSelected == false" @click="setAtivoSelected(false)" />
              <clientes-counter-card :count="emImplantacao" title="Implantaçao" :selected="isStatusSelected('P')"
                @click="filterStatus('P')" col-lg-size="col-lg-2" />
              <clientes-counter-card :count="congelados" title="Congelados" :selected="isStatusSelected('C')"
                @click="filterStatus('C')" col-lg-size="col-lg-2" />
              <clientes-counter-card :count="bloqueados" title="Bloqueados" :selected="isStatusSelected('B')"
                @click="filterStatus('B')" col-lg-size="col-lg-2" />
            </div>
            <div class="row mt-2">
              <clientes-counter-card :count="totalClientes.hotel" title="Hotel" :selected="isVerticalSelected('2')"
                @click="filterVertical('2')" />
              <clientes-counter-card :count="totalClientes.motel" title="Motel" :selected="isVerticalSelected('1')"
                @click="filterVertical('1')" />
              <clientes-counter-card :count="totalClientes.restaurante" title="Restaurante"
                :selected="isVerticalSelected('4')" @click="filterVertical('4')" />
              <clientes-counter-card :count="totalClientes.condominio" title="Condominio"
                :selected="isVerticalSelected('3')" @click="filterVertical('3')" />
            </div>
            <div class="row mt-2" v-if="vertical == 2">
              <clientes-counter-card v-for="item of portes" :count="item.count()" :title="item.name"
                :selected="item.isSelected()" :key="item.id" @click="item.onClick" />
            </div>
            <div class="row mt-2" v-if="vertical == 2">
              <clientes-counter-card :count="totalClientes.modulosConferidos" title="Módulos Conferidos"
                :selected="isModulosConferidos(true)" @click="filterModulosConferidos(true)" />
              <clientes-counter-card :count="totalClientes.modulosNaoConferidos" title="Módulos Não Conferidos"
                :selected="isModulosConferidos(false)" @click="filterModulosConferidos(false)" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <div class="card">
          <div class="pb-0 card-header">
            <div class="d-lg-flex">
              <div>
                <h5 class="mb-0">
                  Clientes({{ clientesFiltered.length }})
                </h5>
              </div>
              <div class="my-auto mt-4 ms-auto mt-lg-0">
                <div class="row">
                  <div class="col-12 d-flex justify-content-end">
                    <router-link :to="{ name: 'Cliente', params: { id: 'new' } }">
                      <button class="btn btn-outline-success btn-sm" type="button" name="button">
                        +&nbsp; Novo Cliente
                      </button>
                    </router-link>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row mb-4">
              <div class="col-md-9">
                <label>Pesquisar Cliente</label>
                <input class="form-control text-uppercase" v-model="search" placeholder="Nome Fantasia, CPF/CNPJ">
              </div>
              <div class="col-md-3">
                <label>Empresa</label>
                <select class="form-control" v-model="empresaSelecionada">
                  <option value="">Todas as Empresas</option>
                  <option v-for="empresa in empresas" :key="empresa.id" :value="empresa.id">
                    {{ empresa.razaoSocial }}
                  </option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 col-sm-12" v-for="cliente of clientesFiltered" :key="cliente.id">
                <cliente-card :cliente="cliente" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="modal-clientes-bloqueados-painel" class="modal fade" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 id="ModalLabel" class="modal-title">
            Selecionar Base
          </h5>
        </div>
        <div class="modal-body">
          <div class="card mb-2">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <label>
                    Pesquisar
                  </label>
                  <input class="form-control text-uppercase" v-model="searchEmpresaHotel" placeholder="Nome Fantasia">
                </div>
              </div>
            </div>
          </div>
          <div class="table-pesquisa">
            <div class="row" v-for="cliente of clientesBloqueadosPainelFiltered" :key="cliente.id">
              <div class="col-md-12">
                <div class="card mb-2">
                  <div class="card-header pb-0 pt-2">
                    <div class="d-flex justify-content-between">
                      <h6>
                        {{ cliente.nomeFantasia }}
                      </h6>
                      <div class="d-flex justify-content-center align-items-center">
                        <badge-vertical :vertical="cliente.vertical" size="sm" />
                      </div>
                    </div>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <table class="table table-bordered">
                        <thead>
                          <tr>
                            <th class="text-sm">ID</th>
                            <th class="text-sm">Nome Fantasia</th>
                            <th class="text-sm text-center">Status</th>
                            <th class="text-sm text-center">Ações</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="empresa of cliente.empresas" :key="empresa.id">
                            <td class="text-sm col-1">
                              <span class="text-dark">
                                {{ empresa.id }}
                              </span>
                            </td>
                            <td class="text-sm col-5">
                              <span class="text-dark my-auto">
                                {{ empresa.nomeFantasia }}
                              </span>
                            </td>
                            <td class="text-center text-sm col-3">
                              <span :class="[`badge bg-${empresa.ativo == 0 ? 'danger' : 'success'} badge-sm`]">
                                {{ empresa.ativo == 0 ? 'Bloqueado' : 'Ativo' }}
                              </span>
                            </td>
                            <td class="text-center text-sm col-3">
                              <argon-button size="xs" :color="empresa.ativo == 0 ? 'danger' : 'success'"
                                variant="outline" @click="toggleEmpresa(cliente.id, empresa)">
                                {{ empresa.ativo == 0 ? 'Desbloquear' : 'Bloquear' }}
                              </argon-button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn bg-gradient-dark btn-sm" data-bs-dismiss="modal" ref="closeModalButton">
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ClientesCounterCard from "./components/ClientesCounterCard.vue";
import ClienteCard from './components/ClienteCard.vue'
import ArgonButton from "@/components/ArgonButton.vue";
import api from '@/services/api';
import { showConfirm, successToast, errorToast } from '@/utils/alerts';
import BadgeVertical from "@/views/pages/components/BadgeVertical.vue";

export default {
  name: "Clientes",
  components: {
    ClienteCard,
    ClientesCounterCard,
    ArgonButton,
    BadgeVertical,
  },
  data() {
    return {
      clientes: [],
      clientesFiltered: [],
      status: 'A',
      porte: '',
      vertical: '',
      search: '',
      modulosConferidos: null,
      isAtivosSelected: true,
      params: {
        nome: '',
        status: 'T',
        vertical: 'T'
      },
      portes: [
        { id: 1, name: 'Basic', count: () => this.totalClientes.basic, isSelected: () => this.isPorteSelected(1), onClick: () => this.filterPorte(1) },
        { id: 2, name: 'Starter', count: () => this.totalClientes.starter, isSelected: () => this.isPorteSelected(2), onClick: () => this.filterPorte(2) },
        { id: 3, name: 'Pro', count: () => this.totalClientes.pro, isSelected: () => this.isPorteSelected(3), onClick: () => this.filterPorte(3) },
        { id: 4, name: 'Enterprise', count: () => this.totalClientes.enterprise, isSelected: () => this.isPorteSelected(4), onClick: () => this.filterPorte(4) },
      ],
      statusClientes: {
        ativos: 0,
        inativos: 0,
        implantacao: 0,
        congelados: 0,
        bloqueados: 0
      },
      totalClientes: {
        starter: 0,
        basic: 0,
        pro: 0,
        enterprise: 0,
        hotel: 0,
        motel: 0,
        restaurante: 0,
        condominio: 0,
        modulosConferidos: 0,
        modulosNaoConferidos: 0,
      },
      empresas: [],
      empresaSelecionada: '',
      clientesBloqueadosPainel: null,
      clientesBloqueadosPainelFiltered: [],
      searchEmpresaHotel: '',
    }
  },
  created() {
    this.fetchData();
    this.fetchEmpresas();
    this.fetchClientesBloqueadosPainelAtivosPms();
  },
  methods: {
    fetchData() {
      this.loading = true;

      api.get(`/clientes`)
        .then(response => {
          const { data } = response;

          this.clientes = data;
          this.setStatusClientes();
          this.filterClientes();
          this.setTotalClientes();
        })
        .catch(e => console.log(e));
    },
    async fetchEmpresas() {
      try {
        const response = await api.get('/empresa');
        this.empresas = response.data;
      } catch (error) {
        console.error(error);
      }
    },
    setAtivoSelected(value) {
      this.isAtivosSelected = value == this.isAtivosSelected ? null : value;

      this.filterClientes();
    },
    setStatusClientes() {
      const { clientes } = this;

      let ativos = 0;
      let inativos = 0;
      let implantacao = 0;
      let congelados = 0;
      let bloqueados = 0;

      this.totalClientes = {
        basic: 0,
        starter: 0,
        pro: 0,
        enterprise: 0,
      }

      for (const cliente of clientes) {
        const { ativo, status } = cliente;

        if (ativo) {
          ativos++;
        } else {
          inativos++
        }

        switch (status) {
          case 0:
            implantacao++;
            break;
          case 2:
            bloqueados++;
            break;
          case 3:
            congelados++;
            break;
        }
      }

      this.statusClientes = {
        ativos,
        inativos,
        implantacao,
        congelados,
        bloqueados
      }
    },
    formatFloat(value) {
      return this.filters.currency(value);
    },
    onSetStatus(status) {
      this.status = status;

      this.filterModules();
    },
    filterClientes() {
      const { status, search, porte, vertical, modulosConferidos, isAtivosSelected, empresaSelecionada } = this;

      let items = [
        ...this.clientes
      ];

      if (isAtivosSelected != null) {
        items = items.filter(item => item.ativo == isAtivosSelected);
      }

      switch (status) {
        case 'P': items = items.filter(item => Number(item.status) == 0);
          break;
        case 'C': items = items.filter(item => Number(item.status) == 3);
          break;
        case 'B': items = items.filter(item => Number(item.status) == 2);
          break;
      }

      if (search) {
        items = items.filter(item => item.search.toLowerCase().indexOf(search.toLowerCase()) > -1);
      }

      if (vertical) {
        items = items.filter(item => item.vertical == vertical);
      }

      if (porte && vertical == 2) {
        items = items.filter(item => item.plano ? item.plano.id == porte : false);
      }

      if (modulosConferidos != null && vertical == 2) {
        items = items.filter(item => item.modulosConferidos == modulosConferidos);
      }

      if (empresaSelecionada) {
        items = items.filter(item => item.conexaUnidadeId == empresaSelecionada);
      }

      this.clientesFiltered = items;

    },
    filterStatus(status) {
      this.status = this.status == status ? 0 : status;

      this.porte = '';
      this.vertical = '';

      this.filterClientes();
      this.setTotalClientes();
    },
    isStatusSelected(status) {
      return this.status == status;
    },
    filterPorte(porte) {
      this.porte = this.porte == porte ? 0 : porte;

      this.modulosConferidos = null;

      this.filterClientes();
      this.setTotalModulosConferidos();
    },
    isPorteSelected(porte) {
      return this.porte == porte;
    },
    filterVertical(vertical) {
      this.vertical = this.vertical == vertical ? 0 : vertical;
      this.porte = '';

      this.filterClientes();
      this.setTotalModulosConferidos();
    },
    isVerticalSelected(vertical) {
      return this.vertical == vertical;
    },
    setTotalModulosConferidos() {
      const { clientesFiltered } = this;

      this.totalClientes.modulosConferidos = 0;
      this.totalClientes.modulosNaoConferidos = 0;

      for (const cliente of clientesFiltered) {
        const { modulosConferidos } = cliente;

        modulosConferidos ? this.totalClientes.modulosConferidos++ : this.totalClientes.modulosNaoConferidos++;
      }
    },
    setTotalClientes() {
      const { clientesFiltered } = this;

      this.totalClientes = {
        basic: 0,
        starter: 0,
        pro: 0,
        enterprise: 0,
        hotel: 0,
        motel: 0,
        restaurante: 0,
        condominio: 0,
        modulosConferidos: 0,
        modulosNaoConferidos: 0,
      }

      for (const cliente of clientesFiltered) {
        const { plano, vertical } = cliente;

        const planoId = plano ? plano.id : 0;

        if (vertical == 2) {
          switch (planoId) {
            case 2: this.totalClientes.starter++;
              break;
            case 3: this.totalClientes.pro++;
              break;
            case 4: this.totalClientes.enterprise++;
              break;
            default:
              this.totalClientes.basic++;
              break;
          }
        }

        switch (vertical) {
          case 1:
            this.totalClientes.motel++;
            break;
          case 2:
            this.totalClientes.hotel++;
            break;
          case 3:
            this.totalClientes.condominio++;
            break;
          case 4:
            this.totalClientes.restaurante++;
            break;
        }
      }
    },
    totalConferidos(value) {
      return this.clientesFiltered.filter(item => item.modulosConferidos == value).length;
    },
    isModulosConferidos(value) {
      return this.modulosConferidos == value;
    },
    filterModulosConferidos(value) {
      this.modulosConferidos = this.modulosConferidos == value ? null : value;

      this.filterClientes();
    },
    fetchClientesBloqueadosPainelAtivosPms() {
      api.get(`/clientes/bloqueados-painel-ativos-pms`)
        .then(({ data }) => {
          this.clientesBloqueadosPainel = data;
          this.filterClientesBloqueadosPainel();
        })
        .catch(error => {
          console.error(error);
        });
    },
    filterClientesBloqueadosPainel() {
      const search = this.searchEmpresaHotel.toLowerCase();

      let empresas = [
        ...this.clientesBloqueadosPainel
      ];

      if (search) {
        empresas = empresas.filter(item => (
          (item.nomeFantasia).toString().toLowerCase().indexOf(search) > -1 ||
          item.empresas.some(empresa => empresa.nomeFantasia.toLowerCase().indexOf(search) > -1) ||
          item.empresas.some(empresa => empresa.razaoSocial.toLowerCase().indexOf(search) > -1) ||
          item.empresas.some(empresa => empresa.id.toString().indexOf(search) > -1)
        ));
      }

      this.clientesBloqueadosPainelFiltered = empresas;
    },
    editCliente(cliente) {
      window.open(`/admin/pages/cliente/${cliente.id}`, '_blank');
    },
    async toggleEmpresa(clienteId, empresa) {
      const title = empresa.ativo ? 'Bloquear Base' : 'Desbloquear Base';
      const message = empresa.ativo ?
        `Ao bloquear a base, o cliente ${empresa.id} - ${empresa.nomeFantasia ?? empresa.razaoSocial} perderá acesso ao PMS, deseja continuar?` :
        `Ao desbloquear a base, o cliente ${empresa.id} - ${empresa.nomeFantasia ?? empresa.razaoSocial} voltará a ter acesso ao PMS, deseja continuar?`;
      const confirm = await showConfirm(message, title);

      if (!confirm) {
        return
      }

      try {
        await api.patch(`/clientes/${clienteId}/empresas/${empresa.id}/toggle`, {
          ativo: !empresa.ativo
        });

        successToast('Status da base atualizado com sucesso');

        this.fetchClientesBloqueadosPainelAtivosPms();
      } catch (error) {
        errorToast(error.data.message || 'Erro ao atualizar status da base');
      }
    }
  },
  computed: {
    emImplantacao() {
      const clientes = this.clientes.filter(item => item.status == 0);

      if (this.isAtivosSelected != null) {
        return clientes.filter(item => item.ativo == this.isAtivosSelected).length;
      }

      return clientes.length;
    },
    congelados() {
      const clientes = this.clientes.filter(item => item.status == 3);

      if (this.isAtivosSelected != null) {
        return clientes.filter(item => item.ativo == this.isAtivosSelected).length;
      }

      return clientes.length;
    },
    bloqueados() {
      const clientes = this.clientes.filter(item => item.status == 2);

      if (this.isAtivosSelected != null) {
        return clientes.filter(item => item.ativo == this.isAtivosSelected).length;
      }

      return clientes.length;
    }
  },
  watch: {
    search: function () {
      this.filterClientes();
    },
    empresaSelecionada: function () {
      this.filterClientes();
    },
    searchEmpresaHotel: function () {
      this.filterClientesBloqueadosPainel();
    }
  }
};
</script>
<style lang="scss" scoped>
.btn {
  margin-bottom: 0 !important;
}

.table tbody tr:last-child td,
.table tbody tr:last-child th {
  border-width: 1px !important;
  border-color: #dee2e6 !important;
}

.modal-body {
  max-height: 500px;
  overflow-y: auto;
}
</style>
